<template>
    <div class="login__wrapper">
        <div class="grid__picture">
            <picture>
                <source media="(min-width: 1025px)"
                        srcset="/images/new-background-auth.jpg"
                        type="image/jpeg">
                <source media="(min-width: 320px)"
                        srcset="/images/new-background-auth-768.jpg"
                        type="image/jpeg">
                <img src="/images/new-background-auth.jpg"
                     alt="">
            </picture>
        </div>
        <div class="login__container">
            <ProfileFillingForm />
        </div>
    </div>
</template>

<script>
import ProfileFillingForm from '@/components/Forms/Login/Templates/Forms/ProfileFilling';

export default {
    name: 'ProfileFilling',

    components: {
        ProfileFillingForm
    }
};
</script>
